import {FC, useState,useEffect} from 'react';
import { Accordion } from 'react-bootstrap';
import ScrollToTopButton from '../../../../../shared/components/molecules/commons/scroll-to-top-button';
import {notificationService} from '../../../../../shared/services/notification-service';
import {AxiosError} from "axios/index";
import {ManageUserService} from "../../../../../shared/services/Report/ManageUser/manage-user";
import {useParams} from 'react-router-dom';
import {Table} from 'react-bootstrap';
import TableHeaderOrdering, {Header} from "../../../../../shared/components/table-header-ordering";
import TableRowNoData from "../../../../../shared/components/molecules/commons/table-row-no-data";
import Moment from "moment";

const headers: Header[] = [
  {
    label: 'ประเภทบุคคลากร',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'ระดับตำแหน่ง',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'ตำแหน่ง',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'ลักษณะตำแหน่ง',
    field: '',
    order: null,
    isOrder: false,
  },{
    label: 'วันที่เริ่มงาน',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'วันที่สิ้นสุด',
    field: '',
    order: null,
    isOrder: false,
  }
];

const PersonnelWorkOrtokor: FC = () => {

  let {employee_id} = useParams();
  const [data, setData] = useState<any>([]);

  const fetchData = async () => {
    try {
      const result = await ManageUserService.getReportEditEmployeeDetailDetail({employee_id: employee_id});
      setData(result);
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification('โหลดข้อมูลไม่สำเร็จ', err.message);
    }
  };

  const tableRowNoData0 = () => {
    if (data[0]?.mof_work_histories?.length === 0) {
      return <TableRowNoData colspan={headers.length}/>;
    }
    return null;
  };

  const tableRowNoData1 = () => {
    if (data[1]?.mof_work_histories?.length === 0) {
      return <TableRowNoData colspan={headers.length}/>;
    }
    return null;
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Accordion className="mt-3">
        <Accordion.Item eventKey="0">
          <Accordion.Header className={`text-mof-primary`}>
            <h5 className="text-mof-primary m-0">ประวัติการทำงาน ของ อตก.</h5>
          </Accordion.Header>
          <Accordion.Body>
            <div className="overflow-auto mt-3">
              {data[0]?.mof_work_histories?.length === 0 && data[1]?.mof_work_histories?.length === 0 ? '' : <h6 className="text-mof-primary m-0 pt-2 pb-2">ข้อมูลก่อนหน้า</h6>}
              <Table bordered>
                <thead>
                  <TableHeaderOrdering headers={headers} onChangeOrder={() => {}} isShow={true}/>
                </thead>
                <tbody>
                  {data[1]?.mof_work_histories?.toReversed().map((data:any,index:any) => {
                    return <tr key={index}>
                      <td>{data.employee_type ? data.employee_type : '-'}</td>
                      <td>{data.position_level ? data.position_level : '-'}</td>
                      <td>{data.position_name ? data.position_name : '-'}</td>
                      <td>{data.position_type ? data.position_type : '-'}</td>
                      <td>{data.start_date ? Moment(data.start_date).add(543, 'year').format('DD/MM/YYYY') : '-'}</td>
                      <td>{data.end_date ? Moment(data.end_date).add(543, 'year').format('DD/MM/YYYY') :  data.is_currently === 1 ? 'ปัจจุบัน' : '-'}</td>
                    </tr>
                  })}
                  {tableRowNoData1()}
                </tbody>
              </Table>
            </div>

            {
              data[0]?.mof_work_histories?.length === 0 && data[1]?.mof_work_histories?.length === 0 ? '' :
              <div className="overflow-auto mt-3">
                <h6 className="text-mof-primary m-0 pt-2 pb-2">ข้อมูลล่าสุด</h6>
                <Table bordered>
                  <thead>
                    <TableHeaderOrdering headers={headers} onChangeOrder={() => {}} isShow={true}/>
                  </thead>
                  <tbody>
                    {data[0]?.mof_work_histories?.toReversed().map((data:any,index:any) => {
                      return <tr key={index}>
                        <td>{data.employee_type ? data.employee_type : '-'}</td>
                        <td>{data.position_level ? data.position_level : '-'}</td>
                        <td>{data.position_name ? data.position_name : '-'}</td>
                        <td>{data.position_type ? data.position_type : '-'}</td>
                        <td>{data.start_date ? Moment(data.start_date).add(543, 'year').format('DD/MM/YYYY') : '-'}</td>
                        <td>{data.end_date ? Moment(data.end_date).add(543, 'year').format('DD/MM/YYYY') :  data.is_currently === 1 ? 'ปัจจุบัน' : '-'}</td>
                      </tr>
                    })}
                    {tableRowNoData0()}
                  </tbody>
                </Table>
              </div>
            }
            
            <div className="mt-3"><ScrollToTopButton/></div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

export default PersonnelWorkOrtokor;